import { Avatar } from "./Avatar";

interface Member {
  id: number | string;
  display_name: string;
}

interface AvatarGroupProps {
  members: Member[];
  selectedIds?: (number | string)[];
  onToggle?: (id: number | string) => void;
  maxVisible?: number;
  size?: "sm" | "md" | "lg";
}

export function AvatarGroup({
  members,
  selectedIds = [],
  onToggle,
  maxVisible = 6,
  size = "md",
}: AvatarGroupProps) {
  const visible = members.slice(0, maxVisible);
  const overflow = members.length - maxVisible;

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {visible.map((m) => (
        <div key={m.id} className="flex flex-col items-center gap-1">
          <Avatar
            name={m.display_name}
            size={size}
            selected={selectedIds.includes(m.id)}
            onClick={onToggle ? () => onToggle(m.id) : undefined}
          />
          <span className="text-[10px] text-muted max-w-[40px] truncate text-center leading-tight">
            {m.display_name.split(" ")[0]}
          </span>
        </div>
      ))}
      {overflow > 0 && (
        <div className={`inline-flex items-center justify-center rounded-full border border-hairline text-muted text-xs font-medium
          ${size === "sm" ? "w-8 h-8" : size === "md" ? "w-10 h-10" : "w-12 h-12"}`}>
          +{overflow}
        </div>
      )}
    </div>
  );
}
